import * as client_hooks from '../../../src/hooks.client.js';


export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18')
];

export const server_loads = [];

export const dictionary = {
		"/": [2],
		"/boards/[id]": [3],
		"/design-system": [4],
		"/early-access-invites": [5],
		"/experiment": [6],
		"/history": [7],
		"/home": [8],
		"/login": [9],
		"/privacy-policy": [10],
		"/reset-password": [11],
		"/sign-up": [12],
		"/subscription": [13],
		"/terms-of-service": [14],
		"/voxel-art-generator": [15],
		"/voxel-art-viewer": [16],
		"/workspace": [17],
		"/world-generator": [18]
	};

export const hooks = {
	handleError: client_hooks.handleError || (({ error }) => { console.error(error) }),

	reroute: (() => {})
};

export { default as root } from '../root.svelte';